import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { Box, Button, Grid, Stack, Typography } from '@mui/material';
import Image from 'next/image';

import Hidden from '../ui/TzoHidden';
import CountDown from './count-down';

const CardForms = () => {
  return (
    <>
      <Box sx={{ maxWidth: 1920, mx: 'auto' }} component="section">
        <Stack
          direction={{ xs: 'column', md: 'row' }}
          justifyContent="space-between"
          alignItems="center"
          spacing={3}
          sx={{ px: { xs: 2, md: 0 }, position: 'relative' }}
        >
          <Box
            sx={{
              textAlign: { xs: 'left', md: 'left' },
              alignItems: 'center',
              display: 'flex',
              width: { xs: 'inherit', lg: 720, xl: 790 },
              minWidth: { xs: 'inherit', md: 427, xl: 530 },
              pl: { xs: 2, sm: 4, md: 5, lg: 5, xl: 5 },
              justifyContent: 'center',
              minHeight: { xs: 10, sm: 20, md: 30 },
            }}
          >
            <Box
              component="header"
              sx={{
                mt: { xs: 2, sm: 4, md: 5 },
                mb: { xs: 2, sm: 4, md: 5 },
              }}
            >
              <Typography
                variant="h1"
                sx={{
                  fontSize: { lg: 40, md: 30, sm: 24, xs: 24 },
                  fontWeight: 600,
                  color: '#374151',
                  mb: 3,
                }}
              >
                E-file{' '}
                <span className="highlight-container">
                  <span className="highlight">IRS Tax Forms</span>
                </span>{' '}
                <span className="highlight-container">
                  <span className="highlight">Securely & Accurately</span>
                </span>{' '}
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 20, md: 18, sm: 16, xs: 16 },
                  fontWeight: 400,
                  display: 'flex',
                  alignItems: 'center',
                  mb: 1,
                }}
              >
                <CheckCircleIcon sx={{ mr: 1 }} /> File ALL Your IRS Forms:
              </Typography>
              <Grid
                container
                spacing={{ xs: 1.5, sm: 2 }}
                m={0}
                sx={{
                  mb: { xs: 3, sm: 4, md: 5 },
                  pl: 3,
                }}
              >
                <Grid size={{ xs: 12, sm: 6 }}>
                  <Box
                    sx={{
                      background: '#fff',
                      p: 1,
                      borderRadius: 2,
                      overflow: 'hidden',
                      mb: 0,
                    }}
                  >
                    <Stack
                      direction="row"
                      justifyContent="flex-start"
                      alignItems="center"
                      spacing={1}
                    >
                      <Image
                        src="/assets/images/business-icon-app.webp"
                        alt="Business Tax Forms"
                        width={40}
                        height={40}
                        style={{ maxWidth: '40px', marginRight: '4px' }}
                      />
                      <Typography
                        sx={{
                          m: 0,
                          fontWeight: 600,
                          textAlign: 'left',
                          lineHeight: 1.2,
                        }}
                      >
                        Business Tax Forms
                        <br />
                        <span style={{ fontWeight: 'normal', fontSize: 13 }}>
                          1120-S, 1065 & CA FTB - 100S
                        </span>
                      </Typography>
                    </Stack>
                  </Box>
                </Grid>{' '}
                <Grid size={{ xs: 12, sm: 6 }}>
                  <Box
                    sx={{
                      background: '#fff',
                      p: 1,
                      borderRadius: 2,
                      overflow: 'hidden',
                      mb: 0,
                    }}
                  >
                    <Stack
                      direction="row"
                      justifyContent="flex-start"
                      alignItems="center"
                      spacing={1}
                    >
                      <img
                        src="/assets/images/employment-icon.webp"
                        alt="Employment Tax Forms"
                        width={40}
                        height={40}
                        style={{ maxWidth: 40, marginRight: 4 }}
                      />
                      <Typography
                        sx={{
                          m: 0,
                          fontWeight: 600,
                          textAlign: 'left',
                          lineHeight: 1.2,
                        }}
                      >
                        Employment Tax Forms
                        <br />
                        <span style={{ fontWeight: 'normal', fontSize: 13 }}>
                          941, 941-X, 941 Schedule R, 940, 943, 943-X, 944, 945,
                          945-X, 94X PIN Request
                        </span>
                      </Typography>
                    </Stack>
                  </Box>
                </Grid>
                <Grid size={{ xs: 12, sm: 6 }}>
                  <Box
                    sx={{
                      background: '#fff',
                      p: 1,
                      borderRadius: 2,
                      overflow: 'hidden',
                      mb: 0,
                    }}
                  >
                    <Stack
                      direction="row"
                      justifyContent="flex-start"
                      alignItems="center"
                      spacing={1}
                    >
                      {/* FIX 4: Add explicit width/height to all img tags to prevent CLS */}
                      <img
                        src="/assets/images/nonprofit-icon.webp"
                        alt="Exempt Organizations Forms"
                        width={40}
                        height={40}
                        style={{ maxWidth: 40, marginRight: 4 }}
                      />
                      <Typography
                        sx={{
                          m: 0,
                          fontWeight: 600,
                          textAlign: 'left',
                          lineHeight: 1.2,
                        }}
                      >
                        Exempt Org. Forms
                        <br />
                        <span style={{ fontWeight: 'normal', fontSize: 13 }}>
                          990-N, 990-EZ, 990, 990-PF, 990-T, 5227, CA 199, CA
                          109, 1120-POL
                        </span>
                      </Typography>
                    </Stack>
                  </Box>
                </Grid>{' '}
                <Grid size={{ xs: 12, sm: 6 }}>
                  <Box
                    sx={{
                      background: '#fff',
                      p: 1,
                      borderRadius: 2,
                      overflow: 'hidden',
                      mb: 0,
                    }}
                  >
                    <Stack
                      direction="row"
                      justifyContent="flex-start"
                      alignItems="center"
                      spacing={1}
                    >
                      <Image
                        src="/assets/images/information-icon.png" // convert to .webp
                        alt="Information Returns"
                        width={40}
                        height={40}
                        style={{ maxWidth: 40, marginRight: 4 }}
                        loading="lazy"
                      />
                      <Typography
                        sx={{
                          m: 0,
                          fontWeight: 600,
                          textAlign: 'left',
                          lineHeight: 1.2,
                        }}
                      >
                        Information Returns
                        <br />
                        <span style={{ fontWeight: 'normal', fontSize: 13 }}>
                          W-2, 1099, W-2G, 1097, 5498, 3921, 3922, 1098, and
                          1095 Forms
                        </span>
                      </Typography>
                    </Stack>
                  </Box>
                </Grid>
                <Grid size={{ xs: 12, sm: 6 }}>
                  <Box
                    sx={{
                      background: '#fff',
                      p: 1,
                      borderRadius: 2,
                      overflow: 'hidden',
                      mb: 0,
                    }}
                  >
                    <Stack
                      direction="row"
                      justifyContent="flex-start"
                      alignItems="center"
                      spacing={1}
                    >
                      <img
                        src="/assets/images/excise-icon.webp"
                        alt="Excise Tax Forms"
                        width={40}
                        height={40}
                        style={{ maxWidth: 40, marginRight: 4 }}
                      />
                      <Typography
                        sx={{
                          m: 0,
                          fontWeight: 600,
                          textAlign: 'left',
                          lineHeight: 1.2,
                        }}
                      >
                        Excise Tax Forms
                        <br />
                        <span style={{ fontWeight: 'normal', fontSize: 13 }}>
                          2290, 8849, 2290 Amendments
                        </span>
                      </Typography>
                    </Stack>
                  </Box>
                </Grid>{' '}
                <Grid size={{ xs: 12, sm: 6 }}>
                  <Box
                    sx={{
                      background: '#fff',
                      p: 1,
                      borderRadius: 2,
                      overflow: 'hidden',
                      mb: 0,
                    }}
                  >
                    <Stack
                      direction="row"
                      justifyContent="flex-start"
                      alignItems="center"
                      spacing={1}
                    >
                      <img
                        src="/assets/images/extension-icon.webp"
                        alt="Extension Forms"
                        width={40}
                        height={40}
                        style={{ maxWidth: 40, marginRight: 4 }}
                      />
                      <Typography
                        sx={{
                          m: 0,
                          fontWeight: 600,
                          textAlign: 'left',
                          lineHeight: 1.2,
                        }}
                      >
                        Extension Forms
                        <br />
                        <span style={{ fontWeight: 'normal', fontSize: 13 }}>
                          7004, 4868, 8868, 8809, 15397
                        </span>
                      </Typography>
                    </Stack>
                  </Box>
                </Grid>
                <Grid size={{ xs: 12, sm: 6 }}>
                  <Box
                    sx={{
                      background: '#fff',
                      p: 1,
                      borderRadius: 2,
                      overflow: 'hidden',
                      mb: 0,
                    }}
                  >
                    <Stack
                      direction="row"
                      justifyContent="flex-start"
                      alignItems="center"
                      spacing={1}
                    >
                      <img
                        src="/assets/images/other-icon.webp"
                        alt="Essential Forms"
                        width={40}
                        height={40}
                        style={{ maxWidth: 40, marginRight: 4 }}
                      />
                      <Typography
                        sx={{
                          m: 0,
                          fontWeight: 600,
                          textAlign: 'left',
                          lineHeight: 1.2,
                        }}
                      >
                        Essential Forms
                        <br />
                        <span style={{ fontWeight: 'normal', fontSize: 13 }}>
                          Form W-9, Form W-8BEN, Form 8655, BOI Report
                        </span>
                      </Typography>
                    </Stack>
                  </Box>
                </Grid>
              </Grid>
              <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 20, md: 18, sm: 16, xs: 16 },
                  fontWeight: 400,
                  display: 'flex',
                  alignItems: 'center',
                  mb: 1,
                }}
              >
                <CheckCircleIcon sx={{ mr: 1 }} /> Fast & Easy: Submit your
                return in just 3 simple steps.
              </Typography>
              <Stack
                direction={{ xs: 'column-reverse', md: 'row' }}
                spacing={{ xs: 1, md: 6 }}
                justifyContent={{
                  xs: 'center',
                  md: 'flex-start',
                }}
                alignItems="center"
                sx={{ mt: 4 }}
              >
                <Box sx={{ textAlign: 'center', mr: { xs: 0, md: 4 } }}>
                  <Button
                    variant="contained"
                    className="btn-primary"
                    href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=homeefilenow`}
                    sx={{
                      transition: 'all 0.3s ease 0s',
                      '&:hover, &:focus, &:active': {
                        transform: 'scale(1.1)',
                      },
                    }}
                  >
                    E-File Now & Save Time!
                  </Button>
                  <Typography
                    variant="body2"
                    sx={{ mt: 1, fontSize: { xs: 11, sm: 14 } }}
                  >
                    Simplify Your Taxes
                  </Typography>
                </Box>
                <Stack
                  direction="row"
                  spacing={2}
                  justifyContent={{
                    xs: 'center',
                    md: 'flex-start',
                  }}
                  alignItems="center"
                >
                  {/* IRS badge */}
                  <Box
                    sx={{
                      mb: { xs: '0 !important', md: '22px !important' },
                    }}
                  >
                    <Image
                      src="/assets/images/irs-authorized.webp"
                      alt="IRS-authorized e-file provider"
                      width={70}
                      height={69}
                      priority={false}
                      sizes="70px"
                      style={{
                        width: '70px',
                        height: '69px',
                      }}
                    />
                  </Box>

                  {/* SOC2 badge */}
                  <Box
                    sx={{
                      mb: { xs: '0px !important', md: '22px !important' },
                    }}
                  >
                    <Image
                      src="/assets/images/tzo-soc2.webp"
                      alt="TZO SOC2 Compliant"
                      width={90}
                      height={89}
                      priority={false}
                      sizes="90px"
                      style={{
                        width: '90px',
                        height: '89px',
                      }}
                    />
                  </Box>
                </Stack>
              </Stack>
            </Box>
          </Box>
          <Hidden lgDown>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'flex-end',
                alignItems: 'flex-end',
                width: 1120,
              }}
              className="banner-bg"
            >
              <Box sx={{ '& img': { mb: '-7px' } }}>
                <Image
                  src="/assets/images/banner-img.webp"
                  alt="E-file IRS Tax Forms Securely & Accurately"
                  width={1070}
                  height={725}
                  priority
                  unoptimized
                  sizes="(max-width: 1200px) 100vw, 1070px"
                  className="img-responsive-banner"
                />
              </Box>
              <Box
                sx={{
                  position: 'absolute',
                  p: 0,
                  width: { lg: 300, xl: 340 },
                  height: { lg: 413, xl: 468 },
                  right: 25,
                  bottom: 0,
                }}
                className="tax-pros-img"
              >
                <Image
                  src="/assets/images/zee-img.webp"
                  alt="Meet Zee — Your Smart Tax Filing Guide"
                  width={300}
                  height={413}
                  priority
                  sizes="(max-width: 1200px) 300px, 340px"
                  className="img-responsive-banner"
                />
              </Box>
              <CountDown />
            </Box>
          </Hidden>
          <Hidden mdUp smDown>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'flex-end',
                width: '100%',
                backgroundPosition: 'center center !important',
                mt: '0 !important',
              }}
              className="banner-bg"
            >
              <Box sx={{ '& img': { mb: '-7px' } }}>
                <picture>
                  <source srcSet="/assets/images/banner-img-sm.webp" />
                  <source srcSet="/assets/images/banner-img-sm.png" />
                  <img
                    src="/assets/images/banner-img-sm.png"
                    alt="E-file IRS Tax Forms Securely & Accurately"
                    className="img-responsive-banner"
                    width={440}
                    height={298}
                    fetchPriority="high"
                  />
                </picture>
              </Box>
              <Box
                sx={{
                  position: 'absolute',
                  p: 0,
                  width: 200,
                  height: 275,
                  right: 10,
                  bottom: 0,
                }}
              >
                <picture>
                  <source srcSet="/assets/images/zee-img.webp" />
                  <source srcSet="/assets/images/zee-img.png" />
                  <img
                    src="/assets/images/zee-img.png"
                    alt="Meet Zee — Your Smart Tax Filing Guide"
                    width={280}
                    height={385}
                    className="img-responsive-banner"
                    fetchPriority="high"
                  />
                </picture>
              </Box>
            </Box>
          </Hidden>
        </Stack>
      </Box>
    </>
  );
};

export default CardForms;
